package kz.dentalcrm.app.screens.positions.edit.mvi

import androidx.compose.runtime.Immutable
import kz.dentalcrm.app.core.base.ViewState

@Immutable
data class EditPositionViewState(
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Editing : ScreenState
        data object Edited : ScreenState
        data object Deleting : ScreenState
        data object Deleted : ScreenState
        data class Error(val error: String) : ScreenState
    }
}
